import request from '@/utils/request'
import { envInfo } from '@/constants/envInfo'

/**
 * 控制源分页查询
 * @param params
 */
export function getControlSourcePage(params) {
    return request({
        url: envInfo.bgApp.basePath + '/tenant/controlsource/page',
        method: 'get',
        params
    })
}

/**
 * 更新控制源
 * @param params
 */
export function updateControlSource(params) {
    return request({
        url: envInfo.bgApp.basePath + '/tenant/controlsource/update',
        method: 'post',
        data: params
    })
}

/**
 * 创建监控点
 * @param params
 */
export function createControlSource(params) {
    return request({
        url: envInfo.bgApp.basePath + '/tenant/controlsource/create',
        method: 'post',
        data: params
    })
}


/**
 * 删除监控点
 * @param params
 */
export function deleteControlSource(params) {
    return request({
        url: envInfo.bgApp.basePath + '/tenant/controlsource/delete/'+params.sourceId,
        method: 'delete'
    })
}

/**
 * 查询控制源类型
 * @param params
 */
export function getControlTypeItem(params) {
    return request({
        url: envInfo.bgApp.lookupPath + '/lookup/item/find/list',
        method: 'get',
        params
    })
}

/**
 * 控制源分页查询
 * @param params
 */
 export function setTimePoint(params) {
    return request({
        url: envInfo.bgApp.basePath + '/tenant/controlsource/setTimePoint',
        method: 'post',
        data: params
    })
}